import InventoryOrderDetailFeature from "./InventoryOrderDetailFeature";

export default InventoryOrderDetailFeature;
